var EditModeItemView = require( 'kitbuilder-layouts/edit-mode' ),
	PanelLayoutView;

PanelLayoutView = Marionette.LayoutView.extend( {
	template: '#tmpl-kitbuilder-panel',

	id: 'kitbuilder-panel-inner',

	regions: {
		content: '#kitbuilder-panel-content-wrapper',
		header: '#kitbuilder-panel-header-wrapper',
		footer: '#kitbuilder-panel-footer',
		modeSwitcher: '#kitbuilder-mode-switcher'
	},

	ui:{
		modalTitle: '#kitbuilder-panel-elements-header',
		panelContainer: '#kitbuilder-panel-content-wrap',
        panelColse: '#kitbuilder-panel-elements-header-close',
        resizeable: '#kitbuilder-panel-content-wrapper-top'
	},

	pages: {},

	childEvents: {
		'click:add': function() {
			this.setPage( 'elements' );
		},
		'editor:destroy': function() {
			this.setPage( 'elements' );
		}
	},

	currentPageName: null,

	_isScrollbarInitialized: false,
    _isDragablePanel: false,
    _isResizablePanel: false,

	initialize: function() {
		this.initPages();
	},

	buildPages: function() {
		var pages = {
			elements: {
				view: require( 'kitbuilder-panel/pages/elements/elements' ),
                title: kitbuilder.translate( 'element' )
			},
			editor: {
				view: require( 'kitbuilder-panel/pages/editor' )
			},
			menu: {
				view: require( 'kitbuilder-panel/pages/menu/menu' ),
				title: kitbuilder.translate( 'global_settings' )
			},
			settingsPage: {
				view: require( 'kitbuilder-panel/pages/page-settings/page-settings' ),
				title: kitbuilder.translate( 'page_settings' )
			}
		};


		return pages;
	},

	initPages: function() {
		var pages;

		this.getPages = function( page ) {
			if ( ! pages ) {
				pages = this.buildPages();
			}

			return page ? pages[ page ] : pages;
		};

		this.addPage = function( pageName, pageData ) {
			if ( ! pages ) {
				pages = this.buildPages();
			}

			pages[ pageName ] = pageData;
		};
	},

	getHeaderView: function() {
		return this.getChildView( 'header' );
	},

	getFooterView: function() {
		return this.getChildView( 'footer' );
	},

	getCurrentPageName: function() {
		return this.currentPageName;
	},

	getCurrentPageView: function() {
		return this.getChildView( 'content' );
	},

	setPage: function( page, title, viewOptions ) {
		var pageData = this.getPages( page );

		if ( ! pageData ) {
			throw new ReferenceError( 'Kitbuilder panel doesn\'t have page named \'' + page + '\'' );
		}

		if ( pageData.options ) {
			viewOptions = _.extend( pageData.options, viewOptions );
		}

		var View = pageData.view;

		if ( pageData.getView ) {
			View = pageData.getView();
		}

		var newContentView = new View( viewOptions );


		this.showChildView( 'content',  newContentView);

        this.ui.modalTitle.html( title || pageData.title );

		this.currentPageName = page;

        this.showContentPanel();
	},

	openEditor: function( model, view ) {
		var currentPageName = this.getCurrentPageName();

		if ( 'editor' === currentPageName ) {
			var currentPageView = this.getCurrentPageView(),
				currentEditableModel = currentPageView.model;

			if ( currentEditableModel === model ) {
				return;
			}
		}

		var elementData = kitbuilder.getElementData( model );

		this.setPage( 'editor', kitbuilder.translate( 'edit_element', [ elementData.title ] ), {
			model: model,
			editedElementView: view
		} );

		var action = 'panel/open_editor/' + model.get( 'elType' );

		// Example: panel/open_editor/widget
		kitbuilder.hooks.doAction( action, this, model, view );

		// Example: panel/open_editor/widget/heading
		kitbuilder.hooks.doAction( action + '/' + model.get( 'widgetType' ), this, model, view );
	},

	onBeforeShow: function() {
		var PanelFooterItemView = require( 'kitbuilder-layouts/panel/footer' ),
			PanelHeaderItemView = require( 'kitbuilder-layouts/panel/header' );

		// Edit Mode
		this.showChildView( 'modeSwitcher', new EditModeItemView() );

		// Header
		this.showChildView( 'header', new PanelHeaderItemView() );

		// Footer
		this.showChildView( 'footer', new PanelFooterItemView() );

		// Added Editor events
		this.updateScrollbar = _.throttle( this.updateScrollbar, 100 );

		this.getRegion( 'content' )
			.on( 'before:show', _.bind( this.onEditorBeforeShow, this ) )
			.on( 'empty', _.bind( this.onEditorEmpty, this ) )
			.on( 'show', _.bind( this.updateScrollbar, this ) );

        this.getRegion( 'content' ).on( 'show', _.bind( this.dragablePanel, this ) );
        this.getRegion( 'content' ).on( 'show empty', _.bind( this.resizablePanel, this ) );

        this.ui.panelColse.on('click', _.bind( this.hideContentPanel, this ));

		// Set default page to elements
		// this.setPage( 'elements' );

		this.listenTo( kitbuilder.channels.data, 'scrollbar:update', this.updateScrollbar );

	},

	onEditorBeforeShow: function() {
		_.defer( _.bind( this.updateScrollbar, this ) );
	},

	onEditorEmpty: function() {
		this.updateScrollbar();
	},

    showContentPanel: function () {
        this.ui.panelContainer.addClass('active');
    },

    hideContentPanel: function () {
        this.setPage( 'elements' );
        this.ui.panelContainer.removeClass('active');
        this.currentPageName = null;
    },

	dragablePanel: function () {
        var $dpanel = this.ui.panelContainer;

        if ( ! this._isDragablePanel ) {
            $dpanel.draggable({handle: "#kitbuilder-panel-elements-header"});
            this._isDragablePanel = true;

            return;
        }
    },

    resizablePanel: function () {
        var $panel = this.ui.resizeable;

        if ( ! this._isResizablePanel ) {
            $panel.resizable({
                delay: 0,
                minWidth: 200,
                start: function( e, ui ) {
                    e.preventDefault();
                },
                resize: function (e, ui) {
                    e.preventDefault();
                    $panel.css({height: ui.size.height, width: ui.size.width});

                },
				stop: function () {
                    kitbuilder.channels.data.trigger( 'scrollbar:update' );
                }
			});
            this._isResizablePanel = true;

        } else {
            $panel.resizable("destroy");
            $panel.resizable({
                delay: 0,
                minWidth: 200,
                resize: function (e, ui) {
                    $panel.css({height: ui.size.height, width: ui.size.width});
                },
                stop: function () {
                    kitbuilder.channels.data.trigger( 'scrollbar:update' );
                }
            });
        }
    },

	updateScrollbar: function() {
		var $panel = this.content.$el;

		if ( ! this._isScrollbarInitialized ) {
			$panel.perfectScrollbar();
			this._isScrollbarInitialized = true;

			return;
		}

		$panel.perfectScrollbar( 'update' );
	}
} );

module.exports = PanelLayoutView;
